import gsap from "gsap";

export default function Entryblock() {
  Alpine.data("entryblock", () => ({
    init() {
      if (this.$refs.media) {
        gsap.fromTo(
          this.$refs.media,
          {
            scale: 1.1,
          },
          {
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: this.$el,
              start: "top bottom",
              end: "top top",
              scrub: true,
            },
          },
        );
      }
    },
  }));
}
